
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { Msg, fromProperties_, fromMemoryEditor_, fromFiles_, notifications_, fromSimulation_ } from "../Model/ModelType.js";
import { Option, notification as notification_1 } from "../fable_modules/Fulma.3.0.0/Elements/Notification.fs.js";
import { Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { notificationStyle } from "./Style.js";
import { tryPick, empty, ofArray, singleton } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { Option as Option_1, delete$ } from "../fable_modules/Fulma.3.0.0/Elements/Delete.fs.js";
import { DrawModelType_SheetT_Model__Model_get_GetNotifications } from "../DrawBlock/Sheet.js";
import * as react from "react";

export function setSimulationNotificationF(n, model) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromSimulation_)(notifications_))(n)(model);
}

export function closeSimulationNotificationF(n, model) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromSimulation_)(notifications_))(undefined)(model);
}

export function setFilesNotificationF(n, model) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromFiles_)(notifications_))(n)(model);
}

export function closeFilesNotificationF(n, model) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromFiles_)(notifications_))(undefined)(model);
}

export function setMemoryEditorNotificationF(n, model) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromMemoryEditor_)(notifications_))(n)(model);
}

export function closeMemoryEditorNotificationF(n, model) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromMemoryEditor_)(notifications_))(undefined)(model);
}

export function setPropertiesNotificationF(n, model) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromProperties_)(notifications_))(n)(model);
}

export function closePropertiesNotificationF(n, model) {
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromProperties_)(notifications_))(undefined)(model);
}

export function errorNotification(text, closeMsg, dispatch) {
    return notification_1(ofArray([new Option(/* Color */ 0, [Color_IColor.IsDanger]), new Option(/* Props */ 3, [singleton(notificationStyle)])]), ofArray([delete$(singleton(new Option_1(/* OnClick */ 3, [(_arg) => {
        dispatch(closeMsg);
    }])), empty()), text]));
}

export function successNotification(text, closeMsg, dispatch) {
    return notification_1(ofArray([new Option(/* Color */ 0, [Color_IColor.IsSuccess]), new Option(/* Props */ 3, [singleton(notificationStyle)])]), ofArray([delete$(singleton(new Option_1(/* OnClick */ 3, [(_arg) => {
        dispatch(closeMsg);
    }])), empty()), text]));
}

export function errorPropsNotification(text) {
    return (dispatch) => errorNotification(text, Msg.ClosePropertiesNotification, dispatch);
}

export function errorFilesNotification(text) {
    return (dispatch) => errorNotification(text, Msg.CloseFilesNotification, dispatch);
}

export function successSimulationNotification(text) {
    return (dispatch) => successNotification(text, Msg.CloseSimulationNotification, dispatch);
}

export function successPropertiesNotification(text) {
    return (dispatch) => successNotification(text, Msg.ClosePropertiesNotification, dispatch);
}

export function warningNotification(text, closeMsg, dispatch) {
    return notification_1(ofArray([new Option(/* Color */ 0, [Color_IColor.IsWarning]), new Option(/* Props */ 3, [singleton(notificationStyle)])]), ofArray([delete$(singleton(new Option_1(/* OnClick */ 3, [(_arg) => {
        dispatch(closeMsg);
    }])), empty()), text]));
}

export function warningPropsNotification(text) {
    return (dispatch) => warningNotification(text, Msg.ClosePropertiesNotification, dispatch);
}

export function warningSimNotification(text) {
    return (dispatch) => warningNotification(text, Msg.CloseSimulationNotification, dispatch);
}

export function displayAlertOnError(dispatch, res) {
    if (res.tag === 1) {
        dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(res.fields[0])]));
    }
}

export function displayAlertOnErrorF(res, model) {
    if (res.tag === 1) {
        return setFilesNotificationF(errorFilesNotification(res.fields[0]), model);
    }
    else {
        return model;
    }
}

export function viewNotifications(model, dispatch) {
    let matchValue, msg;
    const _arg = tryPick((x) => x, ofArray([(matchValue = DrawModelType_SheetT_Model__Model_get_GetNotifications(model.Sheet), (matchValue == null) ? undefined : ((msg = matchValue, (dispatch_1) => errorNotification(msg, Msg.CloseDiagramNotification, dispatch_1)))), model.Notifications.FromSimulation, model.Notifications.FromFiles, model.Notifications.FromMemoryEditor, model.Notifications.FromProperties]));
    if (_arg == null) {
        return react.createElement("div", {});
    }
    else {
        return _arg(dispatch);
    }
}

